<template>
  <div id="browse-marketplace">
    <v-container class="content-wrapper">
      <v-card
        class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
        elevation="3"
        style="border-radius: 24px;"
      >
        <v-tabs v-model="tab" show-arrows active-class="primary200--text">
          <v-tabs-slider color="primary200"></v-tabs-slider>
          <v-tab>{{ 'Services (' + servicesLength + ')' }}</v-tab>
          <v-tab>{{ 'Equipment (' + equipmentLength + ')' }}</v-tab>
          <v-tab>{{ 'Patents (' + patentsLength + ')' }}</v-tab>
          <v-tab>{{ 'Providers (' + providersLength + ')' }}</v-tab>
          <v-tab>{{ 'Hosting Institutions (' + hostingInstitutionLength + ')' }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item :transition="false" :reverse-transition="false" :key="0">
            <v-row class="mt-10 mb-5">
              <v-col cols="12">
                <MarketplaceServicesFilteredViewAll
                  :filteredParams="params"
                  :searchMarketplace="true"
                ></MarketplaceServicesFilteredViewAll>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false" :key="1">
            <v-row class="mt-10 mb-5">
              <v-col cols="12">
                <MarketplaceEquipmentFilteredViewAll
                  :filteredParams="params"
                  :searchMarketplace="true"
                ></MarketplaceEquipmentFilteredViewAll>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false" :key="2">
            <v-row class="mt-10 mb-5">
              <v-col cols="12">
                <MarketplacePatentsFilteredViewAll
                  :filteredParams="params"
                  :searchMarketplace="true"
                ></MarketplacePatentsFilteredViewAll>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false" :key="3">
            <v-row class="mt-10 mb-5">
              <v-col cols="12">
                <MarketplaceProvidersFilteredViewAll
                  :filteredParams="params"
                  :searchMarketplace="true"
                ></MarketplaceProvidersFilteredViewAll>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :transition="false" :reverse-transition="false" :key="4">
            <v-row class="mt-10 mb-5">
              <v-col cols="12">
                <MarketplaceHostingInstitutionsFiltered
                  :filteredParams="hostingParams"
                  :searchMarketplace="true"
                ></MarketplaceHostingInstitutionsFiltered>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import MarketplaceServicesFilteredViewAll from './MarketplaceServicesFilteredViewAll.vue';
import MarketplaceEquipmentFilteredViewAll from './MarketplaceEquipmentFilteredViewAll.vue';
import MarketplaceProvidersFilteredViewAll from './MarketplaceProvidersFilteredViewAll.vue';
import MarketplaceHostingInstitutionsFiltered from './MarketplaceHostingInstitutionsFiltered.vue';
import MarketplacePatentsFilteredViewAll from './MarketplacePatentsFilteredViewAll.vue';

export default {
  name: 'SearchMarketplace',
  components: {
    MarketplaceServicesFilteredViewAll,
    MarketplaceEquipmentFilteredViewAll,
    MarketplaceProvidersFilteredViewAll,
    MarketplaceHostingInstitutionsFiltered,
    MarketplacePatentsFilteredViewAll,
  },
  data() {
    return {
      tab: 0,
      servicesLength: '-',
      providersLength: '-',
      equipmentLength: '-',
      patentsLength: '-',
      hostingInstitutionLength: '-',
      text: '',
      params: {},
      hostingParams: {},
      isInitialLoad: true,
    };
  },
  created() {
    const savedTabIndex = localStorage.getItem('tabIndex');
    if (savedTabIndex) {
      this.tab = parseInt(savedTabIndex, 10);
      localStorage.removeItem('tabIndex');
    }

    this.text = this.$route.query.text;

    this.params = {
      text: this.text,
    };
    this.hostingParams = {
      text: this.text,
      disabled: false,
    };

    this.axios
      .get(`/api/v1/resources?index=0&size=10&text=${this.text}`)
      .then(res => {
        this.servicesLength = res.data.total;
      })
      .catch(err => {
        console.error('Error fetching services:', err);
      });

    this.axios
      .get(`/api/v1/equipment?index=0&size=10&text=${this.text}`)
      .then(res => {
        this.equipmentLength = res.data.total;
      })
      .catch(err => {
        console.error('Error fetching equipment:', err);
      });

    this.axios
      .get(`/api/v1/patent?index=0&size=10&text=${this.text}`)
      .then(res => {
        this.patentsLength = res.data.total;
      })
      .catch(err => {
        console.error('Error fetching patents:', err);
      });

    this.axios
      .get(`/api/v1/providers?index=0&size=10&text=${this.text}`)
      .then(res => {
        this.providersLength = res.data.total;
      })
      .catch(err => {
        console.error('Error fetching providers:', err);
      });

    this.axios
      .get(`/api/v1/hosting-institutions?index=0&size=10&text=${this.text}&disabled=false`)
      .then(res => {
        this.hostingInstitutionLength = res.data.total;
      })
      .catch(err => {
        console.error('Error fetching hosting institutions:', err);
      });
  },
  mounted() {
    this.$nextTick(() => {
      this.isInitialLoad = false;
    });
  },
  watch: {
    tab(newTab) {
      if (this.isInitialLoad) return;
      this.$router.replace({
        query: {
          text: this.$route.query.text,
          tab: newTab,
          index: 0,
          size: 10,
        },
      });
    },
    '$route.query.tab': {
      immediate: true,
      handler(tab) {
        if (tab !== undefined) {
          this.tab = Number(tab);
        }
      },
    },
  },
};
</script>
